// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image._zoomOverlay = overlay;

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';

    image._zoomInitialized = true;
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio, deltaX = 0, deltaY = 0) {
  const overlay = image._zoomOverlay;
  const zoomState = image._zoomState;

  if (!overlay || !zoomState) return;

  // calculate mouse position
  const ratio = image.height / image.width;
  let xPosition, yPosition;

  if (event.type === 'mousemove') {
    const container = image.getBoundingClientRect();
    xPosition = event.clientX - container.left;
    yPosition = event.clientY - container.top;

    zoomState.xPercent = (xPosition / image.clientWidth) * 100;
    zoomState.yPercent = (yPosition / (image.clientWidth * ratio)) * 100;

  } else {
    console.log('not mousemove')
    zoomState.xPercent = Math.max(0, Math.min(100, zoomState.xPercent + deltaX));
    zoomState.yPercent = Math.max(0, Math.min(100, zoomState.yPercent + deltaY));
  }

  overlay.style.backgroundPosition = `${zoomState.xPercent}% ${zoomState.yPercent}%`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
   if (image._zoomOverlay) return;

  const overlay = createOverlay(image);

  image._zoomState = {
    xPercent: 0,
    yPercent: 0,
    zoomRatio: zoomRatio
  };

  image._zoomOverlay = overlay;
  image._zoomInitialized = true;

  // overlay.onclick = () => overlay.remove(); leaving here if we want to add back
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => {
    overlay.remove();
    image._zoomOverlay = null;
    image._zoomState = null;
    image._zoomInitialized = false;
  }
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.setAttribute('tabindex', '0');

    image.onmouseenter = (event) => {
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };

    image.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        magnify(image, zoomRatio);
      }

      if (event.key === 'Escape') {
        image._zoomOverlay?.remove();
        image._zoomOverlay = null;
        image._zoomState = null;
        image._zoomInitialized = false;
      }

      if (image._zoomOverlay && image._zoomInitialized) {
        const moveStep = 8;

        switch (event.key) {
          case 'ArrowUp':
            event.preventDefault();
            moveWithHover(image, event, zoomRatio, 0, -moveStep);
            break;
          case 'ArrowDown':
            event.preventDefault();
            moveWithHover(image, event, zoomRatio, 0, moveStep);
            break;
          case 'ArrowLeft':
            event.preventDefault();
            moveWithHover(image, event, zoomRatio, -moveStep, 0);
            break;
          case 'ArrowRight':
            event.preventDefault();
            moveWithHover(image, event, zoomRatio, moveStep, 0);
            break;
        }
      }

    });

  });
}

enableZoomOnHover(2);
